import { uniqBy } from 'lodash'
import ProductDetailImages from '~/themes/base/components/product/ProductDetailImages'

export default {
  extends: ProductDetailImages,
  data() {
    return {
      selectedMediaIndex: 0,
    }
  },
  computed: {
    hasMultipleImages() {
      return this.sliderItems.length > 1
    },
    normalizedSelectedMediaIndex() {
      if (!this.sliderItems.length) {
        return 0
      }

      return Math.max(0, Math.min(this.selectedMediaIndex, this.sliderItems.length - 1))
    },
    selectedSliderItem() {
      return this.sliderItems[this.normalizedSelectedMediaIndex] || this.sliderItems[0] || null
    },
    selectedMainImage() {
      return this.selectedSliderItem?.src || this.mainImage
    },
    sliderItems() {
      return uniqBy(
        this.lightBoxItems
          .map((item, lightBoxIndex) => ({ ...item, lightBoxIndex }))
          .filter(item => item.type === 'image' && item.src),
        'src',
      )
    },
  },
  watch: {
    lightBoxItems() {
      this.setSelectedMediaIndex(0, { scrollIntoView: false })
    },
  },
  methods: {
    goToNextImage() {
      this.setSelectedMediaIndex(this.normalizedSelectedMediaIndex + 1)
    },
    goToPreviousImage() {
      this.setSelectedMediaIndex(this.normalizedSelectedMediaIndex - 1)
    },
    openSelectedMedia() {
      this.openMedia(this.selectedSliderItem?.lightBoxIndex || 0)
    },
    scrollSelectedThumbnailIntoView() {
      const thumbnailButtons = this.$refs.thumbnailButtons

      if (!Array.isArray(thumbnailButtons) || !thumbnailButtons.length) {
        return
      }

      thumbnailButtons[this.normalizedSelectedMediaIndex]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    },
    selectMedia(index) {
      this.setSelectedMediaIndex(index)
    },
    setSelectedMediaIndex(index, { scrollIntoView = true } = {}) {
      if (!this.sliderItems.length) {
        this.selectedMediaIndex = 0
        return
      }

      this.selectedMediaIndex = Math.max(0, Math.min(index, this.sliderItems.length - 1))

      if (scrollIntoView) {
        this.$nextTick(this.scrollSelectedThumbnailIntoView)
      }
    },
  },
}
